import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import QueryApi from '@/api/query'

export enum Tabs {
    NEW_QUERY,
    SAVED_QUERIES,
}

@Module({ namespaced: true })
export default class QueriesModule extends VuexModule {
    public isLoading: boolean = false
    public error: string = ''
    public result: object[] = []
    public savedQueries: SavedQueryEntity[] = []
    public selectedTab: Tabs = Tabs.NEW_QUERY

    @Action
    public async execute(query: string) {
        this.context.commit('setIsLoading', true)
        this.context.commit('setError', '')
        this.context.commit('setResult', {})

        const response = await QueryApi.executeQuery(btoa(query))

        if (response.status !== 'success') {
            this.context.commit('setError', response.message)
        } else {
            this.context.commit('setResult', response.data!.result)
        }
        this.context.commit('setIsLoading', false)
    }

    @Action
    public async saveQuery(params: SavedQueryEntity) {
        this.context.commit('setIsLoading', true)
        const name = params.name
        const description = params.description

        const query = btoa(params.query)

        const response = await QueryApi.saveQuery(name, description, query)
        this.context.commit('setIsLoading', false)
    }

    @Action
    public async getQueries(): Promise<SavedQueryEntity[]> {
        this.context.commit('setSavedQueries', [])
        const result = await QueryApi.getQueries()

        if (result.data?.queries) {
            this.context.commit('setSavedQueries', result.data.queries)
            return result.data.queries
        }
        return []
    }

    @Action
    public async filterSavedQueries(search: string) {
        this.context.commit('setIsLoading', true)
        this.context.commit('setSavedQueries', [])

        const result = await QueryApi.getQueries(search)

        if (result.data?.queries) {
            this.context.commit('setSavedQueries', result.data.queries)
        }
        this.context.commit('setIsLoading', false)
    }

    @Action
    public selectTab(tab: Tabs) {
        this.context.commit('setSelectedTab', tab)
    }

    @Mutation
    public setIsLoading(isLoading: boolean) {
        this.isLoading = isLoading
    }

    @Mutation
    public setError(error: string) {
        this.error = error
    }

    @Mutation
    public setResult(result: object[]) {
        this.result = result
    }

    @Mutation
    public setSavedQueries(savedQueries: SavedQueryEntity[]) {
        this.savedQueries = savedQueries
    }

    @Mutation
    public setSelectedTab(tab: Tabs) {
        this.selectedTab = tab
    }
}
